export default __webpack_public_path__ + "static/media/sub-dust.57aa4fe8.svg";